import makeApiRequest from './makeApiCall';

//sales
export const getTrialBalance = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(`/trial_balance/get`, 'GET', null, data);
};

export const getTrialBalanceExport = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(`/trial_balance/get_export`, 'GET', null, data);
};

export const getTrialBalanceSimplified = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(
    `/trial_balance/v2/simplified`,
    'POST',
    null,
    data,
  );
};

export const getTrialBalanceSimplifiedExport = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(
    `/trial_balance/v2/simplified/export`,
    'POST',
    null,
    data,
  );
};

export const getTrialBalanceDetailed = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(`/trial_balance/v2/detailed`, 'POST', null, data);
};

export const getTrialBalanceDetailedExport = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(
    `/trial_balance/v2/detailed/export`,
    'POST',
    null,
    data,
  );
};

//export const get//
